/**
 * #377: identity numbers (Aadhaar, PAN, passport, driving licence) arrive
 * masked in every payload. The full value comes only from these POSTs, which
 * the server allows for broker admin / country admin / insurer users and the
 * customer themselves, and writes to the audit log every time.
 */
import api from '@/services/api';

/** The four columns the server masks. GST/CIN are not identity numbers. */
export const MASKED_IDENTITY_FIELDS = ['aadhaar_number', 'pan_number', 'passport_number', 'driving_license'] as const;

export type MaskedIdentityField = (typeof MASKED_IDENTITY_FIELDS)[number];

export function isMaskedIdentityField(key: string): key is MaskedIdentityField {
  return (MASKED_IDENTITY_FIELDS as readonly string[]).includes(key);
}

interface RevealResponse {
  field: string;
  value: string;
}

export async function revealCustomerIdentity(customerId: string, field: MaskedIdentityField): Promise<string> {
  const response = await api.post<RevealResponse>(`/customers/${customerId}/reveal-identity/`, { field });
  return response.data.value;
}

export async function revealLeadIdentity(leadId: string, field: MaskedIdentityField): Promise<string> {
  const response = await api.post<RevealResponse>(`/leads/${leadId}/reveal-identity/`, { field });
  return response.data.value;
}
